import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { overquotaSafeTariffIds } from 'reactApp/appHelpers/featuresHelpers/features/overquotaSafe';
import { features } from 'reactApp/constants/products/features';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';
import type { RootState } from 'reactApp/store';
import type { TariffFeatureListItemType } from 'reactApp/ui/TariffCardNew/components/TariffFeatureList.types';
import { useFeatureData } from 'reactApp/ui/TariffSectionNew/hooks/useFeatures';
import type { TariffByModalTab } from 'reactApp/ui/TariffsModal/TariffsModalContent.types';

const getTariffsList = createSelector(
    [
        (state: RootState, tariffIds: YearAndMonthProductIds, _: TariffFeatureListItemType[]) =>
            ProductsSelectors.getNormalizedTariffsListByProductIds(state, tariffIds, 'single_quota_2022_cloud'),
        (_: RootState, __: YearAndMonthProductIds, features: TariffFeatureListItemType[]) => features,
    ],
    (tariffs, features): TariffByModalTab[] => {
        return tariffs.map((t) => ({ ...t, features }));
    }
);

export function useQuotaTariffs() {
    const [featureList] = useFeatureData(features.restoreFromSafe);
    const tariffs = useSelector((state: RootState) => getTariffsList(state, overquotaSafeTariffIds, featureList));

    return {
        tariffIds: overquotaSafeTariffIds,
        tariffs,
    };
}
